import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId70962: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://car-rental.expedia.com.tw/{locale}-tw/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    includeGT: false,
    showVendorOptions: false,
    clientID: 312139,
    residenceID: "TW",
  },
  hotel: {
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/TW.HPR.012021.pdf",
  },
};
